export default "__VITE_ASSET__4819ebd9__"